import React, { useEffect, useRef, useState } from "react";
import './style.scss'
import * as reactiveUtils from "@arcgis/core/core/reactiveUtils";
import { observerAddToHandles, observerHandles } from "../../../handles/Handles";
import { callback, removeGoogleLayer, initialize } from "./GoogleViewVM";

const GoogleViewWidget = (props: any) => {
  const {view,activeWidget,setMapSplit, mapSplit}=props
  const [visible, setVisible] = useState(false);
  const [active, setActive] = useState(false);
  const [panoramaView, setPanoramaView] = useState<any>({});
  const googleMapDiv = useRef(null);

  useEffect(() => {
    if (activeWidget === "google-street-view") {
      setVisible(true);
      setActive(true)
    } else {
      setVisible(false);
    }
  }, [activeWidget]);

  useEffect(() => {
    if (googleMapDiv.current) {
      initialize(googleMapDiv.current, setPanoramaView,view)
    }
  }, []);

  let style = { display: "initial" };

    if (visible) {
      style.display = "initial";

    } else {
      style.display = "none";
      if (active) {
        setActive(false)
      }
    }

  useEffect(()=>{
    if (view?.ready) {
      let el = view.container
      if (active) {
        el.style.cursor = `url('${process.env.PUBLIC_URL}/ggl.cur'), auto`
        observerAddToHandles(
          reactiveUtils.on(() => view, "click",
            (e) => {
              if(mapSplit===1){
                setMapSplit(2)
              }
              callback(e, visible, panoramaView)
            }
          ),
          "googleStreetViewHandle"
        );
      } else {
        el.style.cursor = "default"
        observerHandles.remove("googleStreetViewHandle")
        removeGoogleLayer(view)
  
      }
  
    }

  },[view,active,visible])

  return (
    <>
      <div style={style}   >
        <div>
        </div>
        <div
          ref={googleMapDiv}
          className='google'
        >
        </div>
      </div>
    </>

  );
};

export default GoogleViewWidget;



